export default __webpack_public_path__ + "images/f1acbe0da91566436f1d0dc2aeea7591-drug-image.svg";